import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { domMax, LazyMotion, MotionConfig } from 'motion/react';
import { ApiError, NetworkError } from '@/api/errors';
import { AuthProvider, meKey } from '@/auth/AuthProvider';
import { TooltipProvider } from '@/design/components/Controls';
import { Toaster } from '@/design/components/toast';
import { router } from './router';

export const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry network hiccups and server errors, never answers the person must act on (4xx).
      retry: (count, error) => count < 2 && (error instanceof NetworkError || (error instanceof ApiError && error.status >= 500)),
      refetchOnWindowFocus: true,
      staleTime: 15_000,
    },
    mutations: { retry: false },
  },
  queryCache: new QueryCache({
    // A 403 can mean the role changed: refresh the permissions so menus and buttons follow.
    onError: (error) => {
      if (error instanceof ApiError && error.status === 403) void queryClient.invalidateQueries({ queryKey: meKey });
    },
  }),
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LazyMotion features={domMax} strict>
          <MotionConfig reducedMotion="user">
            <TooltipProvider>
              <RouterProvider router={router} />
              <Toaster />
            </TooltipProvider>
          </MotionConfig>
        </LazyMotion>
      </AuthProvider>
    </QueryClientProvider>
  );
}
